import React, { useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { UserPlus } from 'lucide-react';

const MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link', 'clean'],
  ],
};

// Reusable rich-text editor for customer email composition.
// Supports a one-click "Insert customer name" merge variable ({{name}}).
export const RichEmailEditor = ({ value, onChange, placeholder, testid = 'rich-email-editor' }) => {
  const quillRef = useRef(null);

  const insertVar = (token) => {
    const editor = quillRef.current?.getEditor?.();
    if (!editor) return;
    const range = editor.getSelection(true);
    const idx = range ? range.index : editor.getLength();
    editor.insertText(idx, token, 'user');
    editor.setSelection(idx + token.length, 0);
  };

  return (
    <div data-testid={testid} className="rich-email-editor">
      <div className="flex items-center gap-2 mb-2">
        <button type="button" onClick={() => insertVar('{{name}}')} data-testid="insert-name-var"
          className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-full bg-rose-soft text-mahogany hover:bg-rose transition-colors">
          <UserPlus className="w-3 h-3" /> Insert customer name
        </button>
        <span className="text-[11px] text-mahogany/50">Use <code className="text-burgundy">{'{{name}}'}</code> and it becomes each person's name.</span>
      </div>
      <ReactQuill ref={quillRef} theme="snow" value={value || ''} onChange={onChange}
        modules={MODULES} placeholder={placeholder} className="bg-white rounded-xl" />
    </div>
  );
};

// Strip HTML tags to test if the message actually has content.
export const richTextIsEmpty = (html) => !html || html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length === 0;

export default RichEmailEditor;
